import api from "../../plugins/api";

const sendMarriedDoc = ({ appealId }) => {
  return api.post('/api/creditPlatform/sendMarriedDoc', { appealId });
};

export default sendMarriedDoc; 
